import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://synesthetic.ca';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`; // You can add this later

export const SEO = ({
  title,
  description,
  image = DEFAULT_IMAGE,
  url,
  type = 'website',
  keywords = [],
  noindex = false,
  canonical,
  schema,
}) => {
  const fullTitle = title ? `${title} | Synesthetic.ca` : 'Synesthetic.ca - Experience Colors Through Letters';
  const fullUrl = url ? `${SITE_URL}${url}` : SITE_URL;
  const keywordsString = keywords.length > 0 ? keywords.join(', ') : 'synesthesia, grapheme-color synesthesia, color perception, letters, numbers, visualization, color profile';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywordsString} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow" />}
      <link rel="canonical" href={canonical || fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Synesthetic.ca" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@synesthetic_ca" />

      {/* Favicon (logo grid) — keep in Helmet so SPA navigations retain it */}
      <link rel="icon" type="image/x-icon" href="/favicon.ico" sizes="any" />
      <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
      <link rel="apple-touch-icon" sizes="180x180" href="/favicon.svg" />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

